 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CallbackView-vue":"CallbackView-vue","EmailsView-vue":"EmailsView-vue","LandingView-vue":"LandingView-vue","LoginView-vue":"LoginView-vue","LogoutView-vue":"LogoutView-vue","PageView-vue":"PageView-vue","RegisterView-vue":"RegisterView-vue","WikiView-vue":"WikiView-vue","account-AspEmails-vue":"account-AspEmails-vue","account-AspEmailsAdd-vue":"account-AspEmailsAdd-vue","account-AspEmailsEdit-vue":"account-AspEmailsEdit-vue","account-AspEvents-vue":"account-AspEvents-vue","account-Emails-vue":"account-Emails-vue","account-Events-vue":"account-Events-vue","account-Profile-vue":"account-Profile-vue","account-Settings-vue":"account-Settings-vue","emails-EmailAdd-vue":"emails-EmailAdd-vue","emails-EmailDraftList-vue":"emails-EmailDraftList-vue","emails-EmailEdit-vue":"emails-EmailEdit-vue","emails-EmailOutboxList-vue":"emails-EmailOutboxList-vue","errors-NotFound-vue":"errors-NotFound-vue","events-EventsAdd-vue":"events-EventsAdd-vue","events-EventsEdit-vue":"events-EventsEdit-vue","events-EventsList-vue":"events-EventsList-vue","events-EventsParticipantsView-vue":"events-EventsParticipantsView-vue","events-EventsView-vue":"events-EventsView-vue","events-TourView-vue":"events-TourView-vue","faqs-Festivals-vue":"faqs-Festivals-vue","faqs-General-vue":"faqs-General-vue","faqs-Goldeimer-vue":"faqs-Goldeimer-vue","faqs-Pool-vue":"faqs-Pool-vue","finance-DepositAdd-vue":"finance-DepositAdd-vue","finance-DepositEditView-vue":"finance-DepositEditView-vue","finance-DepositList-vue":"finance-DepositList-vue","finance-ExpensesAdd-vue":"finance-ExpensesAdd-vue","finance-ExpensesList-vue":"finance-ExpensesList-vue","finance-TakingAdd-vue":"finance-TakingAdd-vue","finance-TakingEdit-vue":"finance-TakingEdit-vue","finance-TakingList-vue":"finance-TakingList-vue","network-ArtistsAdd-vue":"network-ArtistsAdd-vue","network-ArtistsList-vue":"network-ArtistsList-vue","network-CrewView-vue":"network-CrewView-vue","network-CrewsAdd-vue":"network-CrewsAdd-vue","network-CrewsList-vue":"network-CrewsList-vue","network-OrganizersAdd-vue":"network-OrganizersAdd-vue","network-OrganizersList-vue":"network-OrganizersList-vue","network-crew-CrewDisplay-vue":"network-crew-CrewDisplay-vue","organisations-OrganisationView-vue":"organisations-OrganisationView-vue","overview-Home-vue":"overview-Home-vue","users-UsersDisplay-vue":"users-UsersDisplay-vue","users-UsersList-vue":"users-UsersList-vue"}[chunkId]||chunkId) + "." + {"CallbackView-vue":"35db060b","EmailsView-vue":"b96f5312","LandingView-vue":"fcbc4f93","LoginView-vue":"80791fb1","LogoutView-vue":"61ea689d","PageView-vue":"ea143806","RegisterView-vue":"061f432e","WikiView-vue":"456944f3","account-AspEmails-vue":"8a3728bf","account-AspEmailsAdd-vue":"5119721a","account-AspEmailsEdit-vue":"4d97e735","account-AspEvents-vue":"2f66a7f7","account-Emails-vue":"a27e6555","account-Events-vue":"77eb7ce8","account-Profile-vue":"df5424a4","account-Settings-vue":"947a1b98","emails-EmailAdd-vue":"2698c611","emails-EmailDraftList-vue":"f9dd92ff","emails-EmailEdit-vue":"8ebfcb82","emails-EmailOutboxList-vue":"5199e912","errors-NotFound-vue":"a09fb82f","events-EventsAdd-vue":"f5abf5c8","events-EventsEdit-vue":"e8ef13e0","events-EventsList-vue":"0f75935a","events-EventsParticipantsView-vue":"781e078f","events-EventsView-vue":"9c433363","events-TourView-vue":"08c32b1d","faqs-Festivals-vue":"2c681333","faqs-General-vue":"0bd98716","faqs-Goldeimer-vue":"bf2a5b0a","faqs-Pool-vue":"77bf0289","finance-DepositAdd-vue":"61eddb0b","finance-DepositEditView-vue":"b45e0169","finance-DepositList-vue":"3f9a4b3c","finance-ExpensesAdd-vue":"dd41bbe8","finance-ExpensesList-vue":"be1c2ba1","finance-TakingAdd-vue":"fbee91ac","finance-TakingEdit-vue":"9fdf8dd9","finance-TakingList-vue":"32e41e55","network-ArtistsAdd-vue":"e3a5ccad","network-ArtistsList-vue":"c3a5ccc0","network-CrewView-vue":"7f82fd14","network-CrewsAdd-vue":"ad155485","network-CrewsList-vue":"b3ec6c9c","network-OrganizersAdd-vue":"31349df0","network-OrganizersList-vue":"e2c0f9c0","network-crew-CrewDisplay-vue":"7f2cb30a","organisations-OrganisationView-vue":"0eb0e3ff","overview-Home-vue":"09a3c05e","users-UsersDisplay-vue":"b70f43a4","users-UsersList-vue":"7c95bd2a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1);
